import { useAuth } from "@/hooks/useAuth"
import { APP_ROUTES } from "@/common/urls"
import { Home, LogOut, Menu, User } from "lucide-react"
import { Link, NavLink } from "react-router-dom"
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet"
import { useState } from "react"

export default function Header() {
    const { user } = useAuth()
    const [isOpen, setIsOpen] = useState(false)

    return (
        <header className="flex justify-between items-center bg-app-default h-navHeight sticky top-0 z-20">
            <section className="flex justify-start items-center gap-4 h-full">
                <Link
                    to={APP_ROUTES.ROOT.DASHBOARD}
                    className="flex px-10 border-r border-white/10 h-full py-2"
                >
                    <img
                        src="/CMHT_logo_small.svg"
                        alt="CMHT Header Logo"
                        className="h-full"
                    />
                </Link>
                {user && (
                    <NavLink
                        className="text-white rounded-md hover:bg-app-defaultLight/20 px-4 h-10 hidden md:flex justify-center items-center gap-2 text-sm transition-colors"
                        to={APP_ROUTES.ROOT.DASHBOARD}
                    >
                        <Home className="size-4" />
                        <span>Dashboard</span>
                    </NavLink>
                )}
            </section>
            {user && (
                <>
                    {/* Desktop Navigation */}
                    <section className="hidden md:flex justify-end items-center h-full">
                        <NavLink
                            className="text-white bg-app-defaultLight/20 border-r border-white/10 hover:bg-app-defaultLight h-full flex justify-center items-center gap-2 text-sm px-4 min-w-32 transition-all"
                            to={APP_ROUTES.ROOT.ACCOUNT}
                        >
                            <User className="size-4" />
                            <span>Account</span>
                        </NavLink>
                        <Link
                            className="flex bg-app-defaultLight/20 hover:bg-app-defaultLight text-white min-w-32 items-center justify-center text-sm px-4 py-2 h-full transition-all"
                            to={APP_ROUTES.AUTH.LOGOUT}
                        >
                            Logout
                        </Link>
                    </section>

                    {/* Mobile Navigation */}
                    <Sheet open={isOpen} onOpenChange={setIsOpen}>
                        <SheetTrigger className="md:hidden text-white px-10">
                            <Menu className="size-6" />
                        </SheetTrigger>
                        <SheetContent
                            side="right"
                            className="bg-app-default border-app-default [&_svg]:stroke-white"
                        >
                            <nav className="flex flex-col gap-4 mt-8">
                                <NavLink
                                    className="text-white flex justify-start items-center gap-3 text-base"
                                    to={APP_ROUTES.ROOT.DASHBOARD}
                                    onClick={() => setIsOpen(false)}
                                >
                                    <Home className="size-4" />
                                    <span>Dashboard</span>
                                </NavLink>
                                <NavLink
                                    className="text-white flex justify-start items-center gap-3 text-base"
                                    to={APP_ROUTES.ROOT.ACCOUNT}
                                    onClick={() => setIsOpen(false)}
                                >
                                    <User className="size-4" />
                                    <span>Account</span>
                                </NavLink>
                                <Link
                                    className="text-white flex justify-start items-center gap-3 text-base"
                                    to={APP_ROUTES.AUTH.LOGOUT}
                                    onClick={() => setIsOpen(false)}
                                >
                                    <LogOut className="size-4" />
                                    <span>Logout</span>
                                </Link>
                            </nav>
                        </SheetContent>
                    </Sheet>
                </>
            )}
        </header>
    )
}
